<template>
    <small class="text-muted">
        <sup>*</sup>Veuillez utiliser le clavier numérique pour la saisie des prix. Les virgules ne sont pas prise en charge.
    </small>
</template>

<script>
export default {
    name: 'CatSelect'
}
</script>

<style scoped>

</style>
  